import { myCoursesConstants } from '../constants'

export function myCourses(state = { courses: null }, action) {
  let newCourse = action.course
  let { courses } = state
  switch (action.type) {
    case myCoursesConstants.SUCCESS:
      return {
        courses: action.courses,
      }
    case myCoursesConstants.NEW:
      // if (!courses.findIndex(r => r.course.id == newCourse.course.id))
      courses.push(newCourse)
      return {
        courses: courses,
      }
    case myCoursesConstants.UPDATE:
      var course = courses.find((r) => r.course.id === newCourse.course.id)
      if (course) {
        course.userCourse.progress = newCourse.userCourse.progress
      }
      return {
        courses: courses,
      }
    case myCoursesConstants.CLEAR:
      return {
        courses: null,
      }
    default:
      return state
  }
}
